<template>
  <div id="Game" class="Page Game">

    <transition name="scale" mode="out-in">
      <Message ref="message" v-if="!isCompleted && message && !indice && !interaction" @closeMessage="message = null" :message="message" />
    </transition>
    <transition name="scale" mode="out-in">
      <Indice ref="indice" v-if="!isCompleted && indice" @closeIndice="indice = null" :slug="indice" @openInteraction="onOpenInteraction"/>
    </transition>
    <transition name="fade" mode="out-in">
      <Zoom ref="interaction" v-if="!isCompleted && interaction == 'zoom'" @closeInteraction="interaction = null" />
    </transition>

    <transition name="scale" mode="out-in">
      <Word ref="indice" v-if="!isCompleted && interaction == 'word'" @closeInteraction="interaction = null" @gameIsCompleted="onGameIsCompleted"/>
    </transition>

    <transition name="scale" mode="out-in" appear>
      <Compass ref="indice" v-if="withCompass && !isCompleted && !indice && !interaction && !message" />
    </transition>

    <transition name="scale" mode="out-in">
      <Win ref="win" v-if="isCompleted" />
    </transition>

    <transition name="fade">
      <div class="Tuto" v-if="withTuto">
        <span>
          <i class="fal fa-arrows"></i>
        </span>
        
        <h2>tournez la camera</h2>
        <p>avec {{ $tools.isTouchDevice() ? 'votre doigt' : 'la souris' }}</p>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue'
import page from "@/mixins/page"

import Message from '@/components/Message'
import Indice from '@/components/Indice'
import Compass from '@/components/Compass'
import Zoom from '@/components/Zoom'
import Word from '@/components/Word'
import Win from '@/components/partial/Win'

export default {
  components: { Message, Indice, Compass, Zoom, Word, Win },
  mixins: [ page ],
  data () {
    return {
      message: null,
      indice: null,
      interaction: null,
      isCompleted: false,
      delay: null,
      delayPause: false,
      withTuto: false,
      withCompass: false
    }
  },
  watch: {
    withTuto()
    {
      if(!this.withTuto) return

      this.withCompass = true

      setTimeout( () => {
        this.withTuto = false
      }, 4000) 
    },
    interaction()
    {
      this.delayPause = true
      this.delay = setTimeout( () => { this.delayPause = false }, 1000)

      if(this.message || this.indice)
        this.interaction = null

      console.log('interaction', this.interaction)

      if(!this.interaction)
        this.$emit('toggleRender', true)
      else
        this.$emit('toggleRender', false)
    },
    message()
    {
      this.delayPause = true
      this.delay = setTimeout( () => { this.delayPause = false }, 1000)

      if(this.interaction || this.indice)
        this.message = null
      
      if(!this.message)
        this.$emit('toggleRender', true)
      else
        this.$emit('toggleRender', false)
    },
    indice()
    {
      this.delayPause = true
      this.delay = setTimeout( () => { this.delayPause = false }, 1000)

      if(this.message || this.interaction)
        this.indice = null

      if(!this.indice)
        this.$emit('toggleRender', true)
      else
        this.$emit('toggleRender', false)
    }
  },
  methods: {
    onOpenInteraction(slug)
    {
      if(this.delayPause) return
      this.interaction = slug
    },
    onOpenMessage(message)
    {
      if(this.delayPause) return
      this.message = message
    },
    onOpenIndice(slug)
    {
      if(this.delayPause) return
      this.indice = slug
    },
    onGameIsCompleted()
    {
      this.isCompleted = true
      this.$emit('isCompleted')
      this.$emit('toggleRender', false)
    }
  },
  created () {

  },
  mounted () {
    
  }
}
</script>

<style lang="stylus" scoped>

.Game

  pointer-events none

  .Tuto

    position absolute
    top 50%
    left 50%
    max-width 90%
    transform translate(-50%, -50%)
    color white
    text-align center
    text-shadow 1px 1px 3px rgba(0,0,0,0.15)

    h2

      font-size 21px
      margin-bottom 0px

    p

      margin 0px
      font-weight bold

    i, svg

      font-size 31px
      animation camera 4.5s $ease infinite

    span

      height 43px
      width 43px
      border-radius 50%
      display block
      border 3px solid rgba(255,255,255,0.55)
      margin auto auto
      display flex
      align-items center
      justify-content center
      flex-direction column

  @keyframes camera
    0%
      transform translate(0%, 0%)
    12.5%
      transform translate(0%, -20%)
    25%
      transform translate(0%, 0%)
    37.5%
      transform translate(0%, 20%)
    50%
      transform translate(0%, 0%) 
    62.5%
      transform translate(20%, 0%) 
    75%
      transform translate(0%, 0%) 
    87.5% 
      transform translate(-20%, 0%)
    100%
      transform translate(0%, 0%)

  .Page_wrapper

    max-width 860px
    position relative
    width 70%
    text-align center

</style>
